/* eslint-disable no-restricted-imports */

import { Box, Card, CardContent, Typography } from '@material-ui/core';

import PropTypes from 'prop-types';

import { useStyles } from './styles';

export default function MetricsCard({
  label,
  value,
  subtitle,
  icon,
  color = '#1565C0',
  backgroundColor = '#E3F2FD',
}) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <Box className={classes.container}>
          <Box>
            <Typography variant='body2' color='textSecondary' gutterBottom>
              {label}
            </Typography>
            <Typography variant='h4' style={{ fontWeight: 700, color }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant='caption' style={{ color, marginTop: 4 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {icon && (
            <Box
              className={classes.iconBox}
              style={{
                backgroundColor,
              }}
            >
              <Box style={{ color, fontSize: 32 }}>{icon}</Box>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}

MetricsCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
};
